import { DeleteOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useDebounce } from 'react-use';
import condStrings from '../../../../../utils/condStrings';
import UploadCardBody from './UploadCardBody';

function UploadCard(props) {
  const {
    title,
    comment,
    updateComment,
    upload,
    removeFile,
    uploadFile,
    isUploading,
    isRemoving,
  } = props;

  const [error, setError] = React.useState(null);
  const [commentValue, setCommentValue] = React.useState(comment);

  const updatedPadViewComments = React.useCallback(() => {
    if (comment !== commentValue) {
      updateComment(commentValue);
    }
  }, [comment, commentValue, updateComment]);

  useDebounce(updatedPadViewComments, 500, [commentValue]);

  const onCommentChange = React.useCallback((e) => {
    const value = e.target.value ?? '';

    setCommentValue(value);

    if (value.length > 100) {
      setError('Comment should be less than 100 characters');
    } else {
      setError(null);
    }
  }, []);

  return (
    <div className="survey-pad__view__upload-card">
      <div className="upload-card__header">
        <h4 className="upload-card__title">{title}</h4>
        <Input.TextArea
          autoSize={{ minRows: 2 }}
          className="survey-textarea"
          style={{
            minHeight: '78px !important',
            borderColor: error ? '#ff4d4f' : '#e7edf3',
          }}
          placeholder="please describe any obstacles in the image"
          value={commentValue}
          onChange={onCommentChange}
        />
        {error && (
          <div className="ant-form-item-explain ant-form-item-explain-error">
            <div role="alert">{error}</div>
          </div>
        )}
      </div>
      <UploadCardBody
        isLoading={isUploading}
        onClick={uploadFile}
        upload={upload}
      />
      <div className={condStrings('upload-card__footer', !upload && 'hidden')}>
        <Button
          type="link"
          size="small"
          loading={isRemoving}
          icon={<DeleteOutlined />}
          onClick={removeFile}
        >
          {isRemoving ? 'Removing...' : 'Remove'}
        </Button>
      </div>
    </div>
  );
}

UploadCard.propTypes = {
  title: PropTypes.string,
  comment: PropTypes.string,
  updateComment: PropTypes.func,
  upload: PropTypes.object,
  uploadFile: PropTypes.func,
  removeFile: PropTypes.func,
  isUploading: PropTypes.bool,
  isRemoving: PropTypes.bool,
};

export default React.memo(UploadCard);
